module.exports = __webpack_public_path__ + "static/img/image082.0285e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image082.png
// module id = 5B9S
// module chunks = 1